module.exports = __webpack_public_path__ + "static/media/tada.d19b19d5.png";